<template>
  <RouterLink
    v-if="!disabled"
    :to="{ name: routeName }"
    :class="
      isActive ? '!border-primary-500 bg-primary-50 dark:text-slate-700' : ''
    "
    class="group flex items-center gap-1 border-l-4 border-transparent px-3 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50 hover:text-gray-900 dark:text-slate-300 dark:hover:text-slate-700"
  >
    <FontAwesomeIcon :icon="['fal', icon]" fixed-width />
    <span class="cursor-pointer capitalize-first">{{ label }}</span>
  </RouterLink>
  <span
    v-else
    class="group flex items-center gap-1 border-l-4 border-transparent px-3 py-2 text-sm font-medium text-gray-400"
  >
    <FontAwesomeIcon :icon="['fal', icon]" fixed-width />
    <span class="capitalize-first">{{ label }}</span>
  </span>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'SettingsNavLinkComponent',
  components: { FontAwesomeIcon },
  props: {
    routeName: { type: String, required: true },
    icon: { type: String, required: true },
    label: { type: String, required: true },
    disabled: { type: Boolean, required: false, default: false }
  },
  computed: {
    // The list's pages (/settings/company/1, /settings/company/1/activities)
    // are siblings of the list route, not children: match on the path.
    isActive() {
      const path = this.$router.resolve({ name: this.routeName }).path
      return (
        this.$route.path === path || this.$route.path.startsWith(`${path}/`)
      )
    }
  }
}
</script>
